document.addEventListener('DOMContentLoaded', () => {
  console.log('this is product page.');

  const variantEl = document.querySelector('[data-variant-id]');
  const quantityEl = document.querySelector('.product__quantity #quantity');
  const addToCart = document.querySelector('[js-add-to-cart]');

  const select = document.querySelector('.single-option-selector');
  const hiddenInput = document.querySelector('input[data-variant-id]');
  const productDefaultPrice = document.querySelector('.product__price');

  if (select && hiddenInput && productDefaultPrice) {
    select.addEventListener('change', function () {
      const selectedOption = this.options[this.selectedIndex];
      const selectedValue = selectedOption.value;
      const selectedPrice = selectedOption.getAttribute('option-price');

      // Update hidden input
      hiddenInput.setAttribute('data-variant-id', selectedValue);
      hiddenInput.value = selectedValue;

      // Update price display if price exists
      if (selectedPrice) {
        const formattedPrice = selectedPrice;
        productDefaultPrice.textContent = formattedPrice;
      }
    });
  }

  if (addToCart) {
    addToCart.addEventListener('click', (e) => {
      e.preventDefault();
      const vId = variantEl?.value;
      if (vId === '') {
        alert('Please select options.');
        return;
      }

      const quantity = quantityEl?.value;
      const productData = {
        items: [
          {
            id: Number(vId),
            quantity: Number(quantity),
          },
        ],
      };
      addToCart.innerHTML = 'Adding to basket';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(productData),
      })
        .then((res) => {
          console.log('res = ', res);
          res.json();
        })
        .then((response) => {
          console.log('response = ', response);
          addToCart.innerHTML = 'Add to basket';
        })
        .catch((e) => {
          console.log('e = ', e);
          addToCart.innerHTML = 'Add to basket';
        });
    });
  }
});
